import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const HeaderFooter = styled.div`
    margin-top: ${getPurpurSpacing('250')};
    margin-bottom: ${getPurpurSpacing('250')};
    margin-left: 1.875rem;
    margin-right: 1.875rem;

    .button-group .btn {
        margin-bottom: 0;
    }
`;

export const HeaderTitle = styled.h3`
    margin-top: 0;
`;
